import React, { useState, useEffect, useRef } from "react";

import TopHeaderComponent from "./TopHeader/TopHeader";
import useFetchHeader from "hooks/useHeader/useFetchHeader";
import { API_FETCH_STATUS } from "constants/common";

import styles from "./ABheader.scss";
import NavHeader from "./NavHeader/NavHeader";
import LineLoader from "components/lineLoader/lineLoader";
import ErrorCard from "components/errorCard/errorCard.component";

const { SUCCESS, ERROR, LOADING } = API_FETCH_STATUS;
const { b2b_header, expended_navigation, bg_overlay, show_overlay } = styles;

export default function header({ flowName = "", LeadProduct = "Connectivity", LineOfBusiness = "Connectivity", onTalkToExpertClick, onTalkToExpertSubmit }) {
  const { fetchHeader, status, content } = useFetchHeader();
  const [isNavbarExpanded, setIsNavbarExpanded] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    fetchHeader();
  }, []);

  useEffect(() => {
    if (showOverlay) document.body.style.overflowY = "hidden";
    else document.body.style.overflowY = "";
  }, [showOverlay]);

  if (status == ERROR) return <ErrorCard />;
  if (status == LOADING) return <LineLoader show={true} />;

  return (
    <header className={`${b2b_header} ${isNavbarExpanded ? expended_navigation : ""}`}>
      <TopHeaderComponent top_header={content.top_header} flowName={flowName} />
      <NavHeader
        content={content}
        isNavbarExpanded={isNavbarExpanded}
        setIsNavbarExpanded={setIsNavbarExpanded}
        setShowOverlay={setShowOverlay}
        flowName={flowName}
        LeadProduct={LeadProduct}
        LineOfBusiness={LineOfBusiness}
        onTalkToExpertClickCallback={onTalkToExpertClick}
        onTalkToExpertSubmitCallback={onTalkToExpertSubmit}
      />
      <div className={`${bg_overlay} ${showOverlay ? show_overlay : ""}`}></div>
    </header>
  );
}
